import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  Output,
  EventEmitter,
  Input,
} from "@angular/core";
//import { ProductoService } from "src/app/servicios/producto.service";
import { ProductosGruposService } from "src/app/servicios/productos-grupos.service";
import { ProductosLineasService } from "src/app/servicios/productos-lineas.service";
import { ProductosMarcasService } from "src/app/servicios/productos-marcas.service";
import { Utils } from "src/app/utils/utils";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Observable, Subject } from "rxjs";
import { startWith, map } from "rxjs/operators";
//import { MatAutocompleteTrigger } from "@angular/material";
import Swal from "sweetalert2/dist/sweetalert2.all.js"; //CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI
import { MatSnackBar } from "@angular/material/snack-bar";

import { DataTableDirective } from "angular-datatables";

@Component({
  selector: "app-filtro-grupo-linea-marca",
  templateUrl: "./filtro-grupo-linea-marca.component.html",
  styleUrls: ["./filtro-grupo-linea-marca.component.css"],
})
export class FiltroGrupoLineaMarcaComponent implements OnInit {
  @Output()
  propagar = new EventEmitter<string>();

  //@Input() infoFiltro: any;

  productosGrupoLoading = false;
  productosLineaLoading = false;
  productosMarcaLoading = false;

  grupos = [];
  lineas = [];
  marcas = [];

  filteredGrupos: Observable<any[]>;
  filteredLineas: Observable<any[]>;
  filteredMarcas: Observable<any[]>;

  consultaGroup: FormGroup;

  constructor(
    private fb: FormBuilder,
    private servicioGrupo: ProductosGruposService,
    private servicioLinea: ProductosLineasService,
    private servicioMarca: ProductosMarcasService
  ) {
    this.consultaGroup = this.fb.group({
      linea: ["", Validators.required],
      grupo: ["", Validators.required],
      marca: ["", Validators.required],
      producto: [""],
    });

    this.cargarData();
  }

  ngOnInit(): void {}

  cargarData() {
    this.productosGrupoLoading = true;
    this.servicioGrupo.getProductosGrupo().subscribe((data) => {
      this.grupos = data;
      this.grupos.unshift({
        id: "0",
        valor: "TODOS",
      });
      this.productosGrupoLoading = false;
      this.consultaGroup.controls["grupo"].setValue({
        id: "0",
        valor: "TODOS",
      });
      this.filteredGrupos = this.consultaGroup.get("grupo").valueChanges.pipe(
        startWith(""),
        map((grupo) =>
          grupo ? this._filterGrupos(grupo) : this.grupos.slice()
        )
      );
    });

    this.productosLineaLoading = true;
    this.servicioLinea.getProductosLinea().subscribe((data) => {
      this.lineas = data;
      this.lineas.unshift({
        id: "0",
        valor: "TODOS",
      });
      this.productosLineaLoading = false;
      this.consultaGroup.controls["linea"].setValue({
        id: "0",
        valor: "TODOS",
      });

      this.filteredLineas = this.consultaGroup.get("linea").valueChanges.pipe(
        startWith(""),
        map((linea) =>
          linea ? this._filterLineas(linea) : this.lineas.slice()
        )
      );
    });

    this.productosMarcaLoading = true;
    this.servicioMarca.getProductosMarca().subscribe((data) => {
      this.marcas = data;
      this.marcas.unshift({
        id: "0",
        valor: "TODOS",
      });
      this.productosMarcaLoading = false;
      this.consultaGroup.controls["marca"].setValue({
        id: "0",
        valor: "TODOS",
      });
      this.filteredMarcas = this.consultaGroup.get("marca").valueChanges.pipe(
        startWith(""),
        map((marca) =>
          marca ? this._filterMarcas(marca) : this.marcas.slice()
        )
      );
    });
  }

  private _filterGrupos(value: any): any[] {
    let filterValue: any;
    if (typeof value === "object") {
      filterValue = value.valor.toLowerCase();
    } else {
      filterValue = value.toLowerCase();
    }
    //console.log(filterValue);
    //const filterValue = value.valor.toLowerCase();

    return this.grupos.filter(
      (grupo) => grupo.valor.toLowerCase().indexOf(filterValue) > -1
    );
  }

  displayGrupoFn(grupo) {
    //console.log(JSON.stringify(usuario));
    return grupo ? grupo.valor : grupo;
  }

  private _filterLineas(value: any): any[] {
    let filterValue: any;
    if (typeof value === "object") {
      filterValue = value.valor.toLowerCase();
    } else {
      filterValue = value.toLowerCase();
    }
    //console.log(filterValue);
    //const filterValue = value.valor.toLowerCase();

    return this.lineas.filter(
      (linea) => linea.valor.toLowerCase().indexOf(filterValue) > -1
    );
  }

  displayLineaFn(linea) {
    //console.log(JSON.stringify(usuario));
    return linea ? linea.valor : linea;
  }

  private _filterMarcas(value: any): any[] {
    let filterValue: any;
    if (typeof value === "object") {
      filterValue = value.valor.toLowerCase();
    } else {
      filterValue = value.toLowerCase();
    }
    //console.log(filterValue);
    //const filterValue = value.valor.toLowerCase();

    return this.marcas.filter(
      (marca) => marca.valor.toLowerCase().indexOf(filterValue) > -1
    );
  }

  displayMarcaFn(marca) {
    //console.log(JSON.stringify(usuario));
    return marca ? marca.valor : marca;
  }

  limpiarInput(input, autoComplete) {
    switch (input) {
      case "grupo":
        this.consultaGroup.controls["grupo"].setValue("");
        autoComplete.openPanel();
        break;
      case "linea":
        this.consultaGroup.controls["linea"].setValue("");
        autoComplete.openPanel();
        break;
      case "marca":
        this.consultaGroup.controls["marca"].setValue("");
        autoComplete.openPanel();
        break;
      case "producto":
        this.consultaGroup.controls["producto"].setValue("");
        break;
    }
  }

  busqueda() {
    //console.log(JSON.stringify(this.consultaGroup.value));
    let formData = this.consultaGroup.value;
    let infoFiltro = {
      grupo: parseInt(formData.grupo.id),
      linea: parseInt(formData.linea.id),
      marca: parseInt(formData.marca.id),
      producto: formData.producto,
    };

    //console.log(JSON.stringify(infoFiltro));
    this.propagar.emit(JSON.stringify(infoFiltro));
  }
}
